import { apiSpaceUrl } from "utils/urls";

import axios from "axios";

export const getNoteList = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("note", spaceUuid), { params });
    return data;
};

export const getNote = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("note", spaceUuid) + "/no/" + params.note_no);
    return data;
};

export const postNote = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("note", spaceUuid), body);
    return data;
};

export const postNoteWithMarkdown = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("noteCreateWithMarkdown", spaceUuid), body);
    return data;
};

export const patchNote = async (spaceUuid, body) => {
    const { data } = await axios.patch(apiSpaceUrl("note", spaceUuid) + "/" + body.id, body);
    return data;
};

export const deleteNote = async (spaceUuid, params) => {
    const { data } = await axios.delete(apiSpaceUrl("note", spaceUuid) + "/" + params.id);
    return data;
};

export const deleteBulkNote = async (spaceUuid, params) => {
    const { data } = await axios.delete(apiSpaceUrl("note", spaceUuid) + "/bulk-delete", { data: params });
    return data;
};

export const postNoteAsset = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("noteAsset", spaceUuid), body, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return data;
};

export const deleteNoteAsset = async (spaceUuid, assetId) => {
    const { data } = await axios.delete(apiSpaceUrl("noteAsset", spaceUuid) + "/" + assetId);
    return data;
};

export const postNoteRevision = async (spaceUuid, noteId, body = {}) => {
    const { data } = await axios.post(apiSpaceUrl("note", spaceUuid) + "/" + noteId + "/revision", body);
    return data;
};

export const getNoteHistory = async (spaceUuid, noteId) => {
    const { data } = await axios.get(apiSpaceUrl("note", spaceUuid) + "/" + noteId + "/history");
    return data;
};

export const postNoteHistoryRestore = async (spaceUuid, noteId, revisionId, body = {}) => {
    const { data } = await axios.post(
        apiSpaceUrl("note", spaceUuid) + "/" + noteId + "/history/" + revisionId + "/restore",
        body,
    );
    return data;
};

export const getNoteReviews = async (spaceUuid, noteId) => {
    const { data } = await axios.get(apiSpaceUrl("note", spaceUuid) + "/" + noteId + "/reviews");
    return data;
};

export const postNoteReview = async (spaceUuid, noteId, body = {}) => {
    const { data } = await axios.post(apiSpaceUrl("note", spaceUuid) + "/" + noteId + "/reviews", body);
    return data;
};

export const postNoteReviewMessage = async (spaceUuid, noteId, threadId, body = {}) => {
    const { data } = await axios.post(
        apiSpaceUrl("note", spaceUuid) + "/" + noteId + "/reviews/" + threadId + "/messages",
        body,
    );
    return data;
};

export const postNoteReviewResolve = async (spaceUuid, noteId, threadId) => {
    const { data } = await axios.post(
        apiSpaceUrl("note", spaceUuid) + "/" + noteId + "/reviews/" + threadId + "/resolve",
    );
    return data;
};

export const postNoteReviewReopen = async (spaceUuid, noteId, threadId) => {
    const { data } = await axios.post(
        apiSpaceUrl("note", spaceUuid) + "/" + noteId + "/reviews/" + threadId + "/reopen",
    );
    return data;
};
